export enum Namespace {
  invenias = 'invenias',
  bullhorn = 'bullhorn',
  salesforce = 'salesforce',
  section = 'section'
}
